import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BaseForm from 'containers/Base/BaseForm.js';
import {
  initialValues,
  validationSchema,
  initialState,
  generalSection,
} from './options';

import { DEPARTMENT_FORM } from 'utils/constants/departments';
import { translatedKeyValueText } from 'utils/methods/helpers';
import { DepartmentInfo } from 'utils/constants/informationText';
import {
  getSelectedRowID,
  getDepartmentDetailsTransformed,
} from '../Selectors/departmentSelectors';
import { actions as departmentActions } from '../Modules/dataGridTable';

const DepartmentForm = ({
  id,
  departmentDetails,
  editMode,
  closeForm,
  createDepartment,
  editDepartment,
  persistentStateName,
}) => {
  const onCreate = values => {
    const payload = {
      ...values,
    };
    createDepartment({
      department: payload,
    });
  };

  const onEdit = values => {
    const payload = {
      id,
      ...values,
    };
    editDepartment({
      department: payload,
    });
  };

  return (
    <BaseForm
      imageRequired={false}
      edit={editMode}
      initialValues={editMode ? initialValues(departmentDetails) : initialState}
      formTitle={
        editMode
          ? DEPARTMENT_FORM.edit(departmentDetails.generalInfo.name.value)
          : DEPARTMENT_FORM.CREATE
      }
      closeForm={closeForm}
      saveHoverText={
        editMode
          ? translatedKeyValueText('update_value_title', {
              value: departmentDetails.generalInfo.name.value,
            })
          : DEPARTMENT_FORM.CREATE
      }
      onSubmit={editMode ? onEdit : onCreate}
      generalSection={generalSection()}
      validationSchema={validationSchema}
      hoverText={editMode ? departmentDetails.generalInfo.name.value : ''}
      note={DepartmentInfo.note}
      persistentStateName={persistentStateName}
    />
  );
};
const mapStatesToProp = state => ({
  departmentDetails: getDepartmentDetailsTransformed(state),
  id: getSelectedRowID(state),
});
DepartmentForm.propTypes = {
  editMode: PropTypes.bool,
  closeForm: PropTypes.func,
  createDepartment: PropTypes.func,
  editDepartment: PropTypes.func,
  id: PropTypes.string,
  persistentStateName: PropTypes.string,
  departmentDetails: PropTypes.object,
};
const mapDispatchToProps = dispatch => ({
  createDepartment: ({ department }) =>
    dispatch(departmentActions.createRowEntry({ department })),
  editDepartment: ({ department }) =>
    dispatch(departmentActions.createRowEntry({ department })),
});
export default connect(mapStatesToProp, mapDispatchToProps)(DepartmentForm);
